export function percentage(number: number, base: number) {
  return Math.round((number * 100) / base) || 0;
}
